import { RESET_MANAGEMENT, SET_MANAGEMENT, SET_MANAGEMENT_MULTI } from 'services/redux/action-types'
import _ from 'lodash';
import { managementConstants } from 'services/redux/management/constants'
import { createDateHelper, dateFormat } from 'utils/date-helper'

const initialState = {
	[ managementConstants.BUILDINGS ]: {},
	[ managementConstants.FLOORS ]: {},
	[ managementConstants.ROOMS ]: {},
	[ managementConstants.TABLES ]: {},
	
	[ managementConstants.TEAMS ]: {},
	
	[ managementConstants.SELECTED_TIMESLOTS ]: {},
	
	[ managementConstants.MANAGEMENT_SELECTED_START_DATE ]: null,
	[ managementConstants.MANAGEMENT_SELECTED_END_DATE ]: null,
	[ managementConstants.MANAGEMENT_CHART_DATE ]: [ null, null ]
};

export default function management( state = initialState, action ) {
	
	const initialValue = initialState[ action.key ];
	//const initialDefaultValue = _.isArray( initialValue ) ? [] : {};
	
	switch (action.type) {
		case SET_MANAGEMENT:
			let newValue = action.payload;
			
			// Is it an object? Then 'copy' it
			if( _.isObject( initialValue ) ) {
				if( !_.isArray( initialValue ) ) {
					newValue = {
						...action.payload
					};
				} else {
					newValue = [
						...action.payload
					];
				}
			}
			
			return {
				...state,
				[action.key]: newValue
			};
			
		case SET_MANAGEMENT_MULTI:
			return {
				...state,
				...action.payload
			};
			
		case RESET_MANAGEMENT:
			return initialState;
			
		default:
			// Nothing
	}
	
	return state;
}


/**
 *
 * @param state
 * @returns {*}
 */
export const getChartDateRange = ( state ) => {
	let dateRange = state.management[ managementConstants.MANAGEMENT_CHART_DATE ];
	
	// Date range not set? Create it!
	if( dateRange[ 0 ] === null ) {
		dateRange = createDateHelper( () => {
			return state;
		} ).defaultDateRange()
	}

	return dateRange
}

export const selectManagementSelectedStartDate = ( state ) => {
	return (state.management[ managementConstants.MANAGEMENT_SELECTED_START_DATE ] ?? createDateHelper( () => {
		return state;
	} ).date()).format( dateFormat.DATE );
}
export const selectManagementSelectedEndDate = ( state ) => {
	return (state.management[ managementConstants.MANAGEMENT_SELECTED_END_DATE ] ?? createDateHelper( () => {
		return state;
	} ).date()).format( dateFormat.DATE );
}
